import { List } from 'immutable'
import * as testsActions from './actions'
import { Record } from '../transit'
import Test from './Test'
import Exam from './Exam'

const State = Record({
  all: new List(),
  publicTests: new List(),
  currentTest: null,
  loadedTests: false,
  testLoadError: false,
  exam: null,
}, 'tests')

const testsReducer = (state = new State(), action) => {
  switch (action.type) {
    case testsActions.TEST_LOAD_START: {
      return state.set('testLoadError', false)
    }
    case testsActions.TEST_SAVE_SUCCESS:
    case testsActions.TEST_ADD_SUCCESS: {
      const newTest = new Test(action.payload.data)
      return state.set('all', state.get('all').push(newTest))
                  .set('currentTest', newTest)
    }
    case testsActions.TEST_EDIT_SUCCESS: {
      const editedTest = action.payload.data
      let tests = new List(state.get('all')
        .filter(test => test.id !== editedTest.id))
      tests = tests.push(new Test(editedTest))
      return state.set('all', tests)
    }
    case testsActions.TEST_DELETE_SUCCESS: {
      const deletedID = action.payload.data._id
      const tests = new List(state.get('all')
                                .filter(test => test.id !== deletedID))
      return state.set('all', tests)
    }
    case testsActions.TEST_CLEAR_DETAIL: {
      return state.set('currentTest', null)
                  .set('testLoadError', false)
    }
    case testsActions.TEST_LOAD_ERROR: {
      return state.set('currentTest', null)
                  .set('testLoadError', true)
    }
    case testsActions.TESTS_CLEAR: {
      return state.set('all', new List())
    }
    case testsActions.TESTS_LOAD_SUCCESS: {
      const data = action.payload.data
      const newList = new List(data.map(t => new Test(t)))
      return state.set('all', newList)
                  .set('loadedTests', true)
    }
    case testsActions.TEST_LOAD_SUCCESS: {
      const data = action.payload.data
      return state.set('currentTest', new Test(data))
                  .set('testLoadError', false)
    }
    case testsActions.GET_PUBLIC_TESTS_SUCCESS: {
      const tests = new List(action.payload.data.map(item => new Test(item)))
      return state.set('publicTests', tests)
    }
    case testsActions.INIT_TEST: {
      const data = action.payload
      return state.set('exam', new Exam({ ...data }))
    }
    case testsActions.INIT_ANSWERS: {
      const data = action.payload
      const exam = state.get('exam').toJS()
      exam.lessons[data.id] = {
        lesson: data.id,
        answers: data.answers,
        points: 0,
        maxPoints: data.answers.reduce((n, answer) => n + (answer.maxPoints || 1), 0),
      }
      exam.maxPoints += exam.lessons[data.id].maxPoints
      return state.set('exam', new Exam(exam))
    }
    case testsActions.UPDATE_ANSWERS: {
      const data = action.payload
      const exam = state.get('exam').toJS()
      const lesson = exam.lessons[data.id]
      lesson.answers[data.wordId].userAnswer = data.value
      exam.lessons[data.id] = lesson
      return state.set('exam', new Exam(exam))
    }
    case testsActions.SET_RESULT: {
      const data = action.payload
      const exam = state.get('exam').toJS()
      exam.finished = true
      exam.points += data.points
      Object.assign(exam.lessons[data.id], { ...data })
      return state.set('exam', new Exam(exam))
    }
    case testsActions.CLEAR_ANSWERS: {
      return state.set('exam', null)
    }
    default: {
      return state
    }
  }
}

export default testsReducer



// WEBPACK FOOTER //
// ./src/common/tests/reducer.js